/**
 * Extern Labs — the ordered step sequence. Vertical-AGNOSTIC.
 *
 * Every vertical runs the SAME 18 steps and the same four mechanics; only the content differs (see
 * `./types.ts`). So the step vocabulary lives in the engine, not in a pack — a pack cannot add,
 * remove or reorder steps. That is deliberate: the step ids are the analytics vocabulary. The live
 * board reads `step` / `step_index` off `*_step_viewed` and the abandon-point funnel is keyed on
 * these exact strings, so a vertical that invented its own steps could not be compared to another.
 *
 * Mirrors `finance-discovery/_data/steps.ts` verbatim. Finance keeps its own copy while it stays
 * frozen (it is live and mid-experiment); when it migrates onto the engine, that copy is deleted and
 * this becomes the single source of truth.
 */

export const STEPS = [
  'welcome',
  'm1-intro',
  'm1-activity',
  'm1-results',
  'm1-complete',
  'm2-intro',
  'm2-activity',
  'm2-results',
  'm2-complete',
  'm3-intro',
  'm3-reading',
  'm3-activity',
  'm3-complete',
  'm4-intro',
  'm4-selection',
  'm4-activity',
  'm4-complete',
  'recommendations',
] as const;

export type Step = (typeof STEPS)[number];

/** The four modules, in order. Each is weighted evenly (25%) by the progress bar. */
export const MODULE_COUNT = 4;

/** Matches the four module-completion steps (`m1-complete` … `m4-complete`); group 1 = the module id. */
export const MODULE_COMPLETE_STEP_RE = /^(m[1-4])-complete$/;
